module.exports = __webpack_public_path__ + "static/media/email.8818ae65.svg";